import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-heading p-white">Privacy Policy</h1>
      <p className="terms-updated p-white">Last updated: 6th July 2025</p>

        <p className='p-white'>
          At Link Hangouts, your privacy is important to us. This Privacy Policy explains how we collect, use,
          and protect your personal information when you use our website and services.
        </p>

        <h2 className='p-white'>Who We Are</h2>
        <p className='p-white'>
          Link Hangouts is a vibrant lifestyle company based in Lagos, Nigeria. We curate and host
          exceptional events, parties, and hangouts that bring people together to create lasting memories.
          Our website is used to sell event tickets, share updates, and showcase media from past events.
        </p>

        <h2 className='p-white'>What Information We Collect</h2>
        <ul className='p-white'>
          <li>
            <strong>Personal Information:</strong> Name, email address, phone number, and payment details when you purchase tickets or contact us.
          </li>
          <li>
            <strong>Event Participation Info:</strong> Data related to the events you attend or are interested in.
          </li>
          <li>
            <strong>Media Content:</strong> Photos or videos taken during events (with appropriate consent).
          </li>
          <li>
            <strong>Website Usage Data:</strong> Information like IP address, browser type, and pages visited, collected through cookies and analytics tools.
          </li>
        </ul>

        <h2 className='p-white'>How We Use Your Information</h2>
        <ul className='p-white'>
          <li>Process ticket purchases and send confirmation emails</li>
          <li>Communicate with you about upcoming events, offers, or updates</li>
          <li>Improve our website and event experience</li>
          <li>Share event highlights (photos/videos) with respect to your privacy and rights</li>
        </ul>

        <h2 className='p-white'>Sharing Your Information</h2>
        <p className='p-white'>
          We do not sell your personal data. We may share limited information with trusted third parties such as:
        </p>
        <ul className='p-white'>
          <li>Payment processors (e.g., Paystack, Flutterwave)</li>
          <li>Event partners or service providers (strictly for event operations)</li>
          <li>Legal authorities if required by law</li>
        </ul>

        <h2 className='p-white'>Your Rights</h2>
        <ul className='p-white'>
          <li>Access or update your personal data</li>
          <li>Opt-out of promotional messages</li>
          <li>Request the deletion of your data from our systems</li>
        </ul>
        <p className='p-white'>
          To exercise these rights, contact us at: contact@thelinkhangout.com
        </p>

        <h2 className='p-white'>Cookies</h2>
        <p className='p-white'>
          We use cookies to enhance your browsing experience and analyze site traffic. You can choose to
          disable cookies through your browser settings.
        </p>

        <h2 className='p-white'>Media & Consent</h2>
        <p className='p-white'>
          By attending our events, you may be photographed or filmed. We may use this content for
          marketing or promotional purposes. If you prefer not to appear in our media, please let our team
          know at the event or email us afterward.
        </p>

        <h2 className='p-white'>Data Security</h2>
        <p className='p-white'>
          We take appropriate measures to protect your data, including encryption, secure payment systems,
          and limited access protocols.
        </p>

        <h2 className='p-white'>Updates to This Policy</h2>
        <p className='p-white'>
          We may update this Privacy Policy occasionally. Changes will be posted on this page with the
          updated date.
        </p>

        <h2 className='p-white'>Contact Us</h2>
        <p className='p-white'>
          If you have questions about this policy or how your information is handled, please contact:
          <br />
          <strong>Email:</strong> contact@thelinkhangout.com
          <br />
          <strong>Location:</strong> Lagos, Nigeria
        </p>
      </div>
  );
};

export default PrivacyPolicy;
